import { createServicePartnerCollection } from "@/lib/api/resources/servicePartnerCollections";
import { ServicePartnerCollectionFormData } from "@rumble-it/common-lib/types/models/ServicePartnerCollection.interface";
import { useMutation } from "@tanstack/react-query";
import { Col, Form, message, Row } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ServicePartnerCollectionFormCard } from "./components/ServicePartnerCollectionFormCard";
import { ServicePartnersCard } from "./components/ServicePartnersCard";

export const ServicePartnersCollectionCreate = () => {
  const navigate = useNavigate();

  const [form] = Form.useForm<ServicePartnerCollectionFormData>();

  const [selectedServicePartnerIds, setSelectedServicePartnerIds] = useState<
    string[]
  >([]);

  const createServicePartnerCollectionMutation = useMutation({
    mutationFn: (data: ServicePartnerCollectionFormData) =>
      createServicePartnerCollection(data),
    onSuccess: () => {
      navigate(`/service-partners/collections`);
      message.success("Subnetwerk succesvol aangemaakt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het aanmaken van het subnetwerk",
      ),
  });

  const handleFinish = (values: ServicePartnerCollectionFormData) => {
    createServicePartnerCollectionMutation.mutate({
      ...values,
      servicePartners: selectedServicePartnerIds.length
        ? selectedServicePartnerIds
        : null,
    });
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnerCollectionFormCard
            title="Subnetwerk aanmaken"
            buttonText="Aanmaken"
            submitting={createServicePartnerCollectionMutation.isPending}
          />
        </Col>
        <Col xxl={{ span: 12 }} span={24}>
          <ServicePartnersCard
            editMode
            selectedServicePartnerIds={selectedServicePartnerIds}
            setSelectedServicePartnerIds={setSelectedServicePartnerIds}
          />
        </Col>
      </Row>
    </Form>
  );
};
